<template>
    <div v-if="cart" class="order-summary">
        <div class="order-summary--header">
            <div class="order-summary--header--col">
                <h3>Súhrn objednávky<span>:</span> <strong>{{ cart.final_price_formatted }} <small>€</small></strong></h3>
            </div>

            <div class="order-summary--header--col" id="btn-order-summary">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 9L12 16L5 9" stroke="#1376C1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>

        <div class="order-summary--body">
            <div class="order-summary--body--row" v-for="cartProduct in cart.cart_products" :key="cartProduct.id">
                <div class="order-summary--body--row--col">
                    <strong v-if="[2, 3, 4].includes( cartProduct.product.product_type.id )">
                        {{ cartProduct.product.product_type.title }}:
                    </strong>

                    {{ cartProduct.product.title }}
                </div>

                <div class="order-summary--body--row--col">
                    {{ cartProduct.product_quantity }}x
                </div>

                <div class="order-summary--body--row--col sum-col">
                    {{ cartProduct.product_price_with_tax_final_sum_formatted }}
                    <small v-if="cartProduct.discount_status">{{ cartProduct.product_price_with_tax_sum_formatted }}</small>
                ​​</div>
            </div>

            <div v-if="cart.delivery_method" class="order-summary--body--row row-simple">
                <div class="order-summary--body--row--col">
                    <strong>Doprava:</strong>
                    {{ cart.delivery_method.title }}
                </div>

                <div class="order-summary--body--row--col sum-col">
                    {{ cart.delivery_price_with_tax_formatted }}​
                </div>
            </div>

            <div v-if="cart.payment_method" class="order-summary--body--row row-simple">
                <div class="order-summary--body--row--col">
                    <strong>Platba:</strong>
                    {{ cart.payment_method.title }}
                </div>

                <div class="order-summary--body--row--col sum-col">
                    {{ cart.payment_price_with_tax_formatted }}
                </div>
            </div>

            <div v-if="cart.discount" class="order-summary--body--row row-simple">
                <div class="order-summary--body--row--col">
                    <strong>Zľavový kód:</strong>
                    {{ cart.discount.title }} ({{ cart.discount.code }})
                </div>

                <div class="order-summary--body--row--col sum-col">
                    {{ cart.discount.discount_value_final_formatted }}
                </div>

            </div>

            <div class="order-summary--body--row row-simple sum-row">
                <div class="order-summary--body--row--col">Suma celkom</div>

                <div class="order-summary--body--row--col sum-col">
                    {{ cart.final_price_formatted_with_currency }}
                    <small v-if="cart.discount_rule_id">{{ cart.final_price_without_discount_formatted }}</small>
                ​</div>
            </div>
        </div>
    </div>

    <div class="order-discount">
        <div v-if="!showDiscountBar" class="order-discount--title">
            <span class="btn btn-text-action-black" @click="showDiscountBar = !showDiscountBar">Vložiť zľavový kód</span>
        </div>

        <div v-if="showDiscountBar" class="order-discount--body">
            <div class="order-discount--body--col">
                <label class="form-label" :class="discountClass">
                    <h4>Zľavový kód</h4>

                    <input class="form-input" type="text" name="discount-code" v-model="discountCode">

                    <div v-if="errors && errors.code" class="form-error">
                        {{ errors.code[0] }}
                    </div>

                    <div v-if="cart.discount?.code" class="form-error success">
                        Zľava bola aplikovaná. {{ cart.discount?.description }}
                    </div>
                </label>
            </div>

            <div class="order-discount--body--col">
                <span class="btn btn-default btn-padding-medium" @click="applyCode()">Aplikovať</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            onUpdate: {
                type: Function
            },
            cart: {
                type: Object
            }
        },
        data() {
            return {
                showDiscountBar: this.cart.discount?.code ? true : false,
                discountCode: this.cart.discount?.code ?? null,
                errors: null
            }
        },
        computed: {
            discountClass() {
                let cls = ''

                if ( this.errors ) cls = 'form-label-error'

                if ( this.cart.discount ) cls = 'form-label-success'

                return cls
            }
        },
        methods: {
            applyCode() {
                axios.post(`/api/shop/cart/${this.cart.id}/update-discount-code`, { cart_id: this.cart.id, code: this.discountCode, user_id: this.cart.user_id })
                .then(response => {
                    this.errors = null
                    this.$emit('update')
                }).catch(errors => { this.errors = errors.response.data.errors })
            }
        },
    }
</script>
